import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppsFilters {
  appsFilters: {
    industries: string[];
  };
}

const appsFiltersInitialState = () => {
  return {
    industries: [],
  };
};

const initialState: AppsFilters = {
  appsFilters: appsFiltersInitialState(),
};

export const appsFiltersSlice = createSlice({
  name: 'appsFilters',
  initialState,
  reducers: {
    setAppsFilters: (state, action: PayloadAction<Partial<AppsFilters['appsFilters']>>) => {
      state.appsFilters = {
        ...state.appsFilters,
        ...action.payload,
      };
    },
    resetAppsFilters: (state) => {
      state.appsFilters = appsFiltersInitialState();
    },
  },
});

export const { setAppsFilters, resetAppsFilters } = appsFiltersSlice.actions;
export default appsFiltersSlice.reducer;
